'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.markBoardsAsSeen = exports.fetchModifiedBoards = exports.modifiedElementsError = exports.setModifiedElements = undefined;

var _http = require('../utils/services/http');

var _http2 = _interopRequireDefault(_http);

var _timeUtil = require('../../common/utils/timeUtil');

var _errorUtil = require('../utils/errorUtil');

var _notificationConstants = require('./notificationConstants');

var _elementActions = require('../element/elementActions');

var _notificationConstants2 = require('../../common/notifications/notificationConstants');

var _analytics = require('../analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Util
var setModifiedElements = exports.setModifiedElements = function setModifiedElements(modifiedElements) {
    return {
        type: _notificationConstants.MODIFIED_ELEMENTS_SET,
        modifiedElements: modifiedElements
    };
};

var modifiedElementsError = exports.modifiedElementsError = function modifiedElementsError(error) {
    return {
        type: _notificationConstants.MODIFIED_ELEMENTS_ERROR,
        error: (0, _errorUtil.extractErrorDetailsForAction)(error)
    };
};

var trackNotificationsAnanlyticsEvent = function trackNotificationsAnanlyticsEvent(modifiedElements, lastViewedNotifications) {
    var unseenCount = Object.keys(modifiedElements).map(function (key) {
        return modifiedElements[key];
    }).filter(function (modified) {
        return modified.active && modified.modifiedTime > lastViewedNotifications;
    }).length;

    if (unseenCount > 0) (0, _analytics.analyticsEvent)('loaded-unseen-notifications', { unseen_count: unseenCount });
};

var fetchModifiedBoards = exports.fetchModifiedBoards = function fetchModifiedBoards() {
    return function (dispatch, getState) {
        var lastFetch = getState().getIn(['notifications', 'fetchedTime']);

        return (0, _http2.default)({ url: 'notifications/modified-elements', timeout: 30000, params: { after: lastFetch } }).then(function (response) {
            var _response$data = response.data,
                modifiedElements = _response$data.modifiedElements,
                elements = _response$data.elements;


            dispatch({ type: _notificationConstants.MODIFIED_ELEMENTS_ADD, modifiedElements: modifiedElements });
            if (Object.keys(elements).length) dispatch((0, _elementActions.loadElements)(elements));

            trackNotificationsAnanlyticsEvent(modifiedElements, getState().getIn(['app', 'currentUser', 'lastCheckedNotifications']));
        }).catch(function (err) {
            dispatch(modifiedElementsError(err));
            return Promise.reject(err);
        });
    };
};

var markBoardsAsSeen = exports.markBoardsAsSeen = function markBoardsAsSeen(_ref) {
    var ids = _ref.ids,
        userId = _ref.userId,
        _ref$sync = _ref.sync,
        sync = _ref$sync === undefined ? true : _ref$sync;
    return {
        type: _notificationConstants2.MODIFIED_ELEMENTS_MARK_SEEN,
        ids: ids,
        userId: userId,
        sync: sync,
        timestamp: (0, _timeUtil.getTimestamp)()
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/notifications/notificationActions.js
// module id = 460
// module chunks = 0